/**
 * @generated SignedSource<<c474199270c2abc432ee44197d2d85c1>>
 * @relayHash 693b273497a87a10c6d692e4c9b4e908
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 745cc2545c4900a76afed610fe7b82f93cb43ad55c08f3218dc6b9d231e6cfab

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  otherContentStatus: string;
  spaceKey: string;
  transitionType?: ConfluenceApprovalTransitionType | null | undefined;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null | undefined;
    readonly displayProperties: {
      readonly color: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly confluence_contentApprovalsSpaceSettingConfig: {
    readonly config: {
      readonly disallowFirstPublish: boolean;
    } | null | undefined;
  } | null | undefined;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null | undefined;
      readonly contentStatus: string | null | undefined;
      readonly contentVersion: number | null | undefined;
      readonly creator: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly isActive: boolean | null | undefined;
      readonly lastModificationDate: {
        readonly value: string;
      } | null | undefined;
      readonly modifier: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly workflowId: string | null | undefined;
      readonly workflowStatusId: string | null | undefined;
    } | null | undefined;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null | undefined;
      readonly creator: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly creatorAaid: string | null | undefined;
      readonly id: string;
      readonly reviewComment: string | null | undefined;
      readonly reviewLastModified: {
        readonly value: string;
      } | null | undefined;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null | undefined;
        readonly decisionId: string | null | undefined;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null | undefined;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null | undefined;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null | undefined;
        readonly reviewerId: string | null | undefined;
        readonly user: {
          readonly displayName: string | null | undefined;
          readonly id: string | null | undefined;
          readonly isActive: boolean | null | undefined;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
    } | null | undefined;
  } | null | undefined;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null | undefined;
      readonly version: {
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly id: string | null | undefined;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null | undefined;
      };
    };
  } | null | undefined;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherContentStatus"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledFeatures",
          "kind": "LinkedField",
          "name": "enabledFeatures",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isContentApprovalsEnabled"
            }
          ]
        }
      ]
    }
  ]
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "args": [
    (v8/*: any*/),
    {
      "kind": "Variable",
      "name": "spaceKey",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalsSpaceSettingConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "disallowFirstPublish"
        }
      ]
    }
  ]
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "status"
},
v12 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v13 = {
  "args": [
    (v8/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v14 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v15 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v16 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v17 = [
  (v8/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "success"
},
v19 = {
  "kind": "ScalarField",
  "name": "message"
},
v20 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v21 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v22 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v21/*: any*/)
      ]
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v24 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v23/*: any*/)
  ]
},
v25 = [
  (v8/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v27 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v28 = {
  "kind": "ScalarField",
  "name": "value"
},
v29 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v30 = [
  (v6/*: any*/),
  (v27/*: any*/),
  (v26/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v28/*: any*/),
      (v29/*: any*/)
    ]
  }
],
v31 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = [
  (v28/*: any*/)
],
v33 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v26/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v32/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v30/*: any*/)
    }
  ]
},
v34 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "creatorAaid"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v32/*: any*/)
    },
    (v23/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewComment"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v32/*: any*/)
    },
    (v31/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "decisionId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerId"
        },
        {
          "kind": "ScalarField",
          "name": "required"
        },
        {
          "kind": "ScalarField",
          "name": "principalType"
        },
        {
          "kind": "ScalarField",
          "name": "principalId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerDecisionStatus"
        },
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v32/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v27/*: any*/),
            (v26/*: any*/),
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                (v29/*: any*/),
                (v28/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v35 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v20/*: any*/),
        (v21/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v6/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v7/*: any*/),
      (v9/*: any*/),
      {
        "args": (v10/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/)
            ]
          }
        ]
      },
      (v13/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v17/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v22/*: any*/),
          (v24/*: any*/)
        ]
      },
      {
        "args": (v25/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v22/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v7/*: any*/),
      (v9/*: any*/),
      {
        "args": (v10/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      (v13/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v17/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v35/*: any*/),
          (v24/*: any*/)
        ]
      },
      {
        "args": (v25/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v35/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "693b273497a87a10c6d692e4c9b4e908",
    "id": "745cc2545c4900a76afed610fe7b82f93cb43ad55c08f3218dc6b9d231e6cfab",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey){config{disallowFirstPublish}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "a1c7a1d50bce74f5dbcec60a719945e9";

export default node;
